import axios from 'axios';
import { TimePeriodFilterEnum } from '../../Enum/TimePeriodFilterEnum';
import { WidgetTimeFilterEnum } from '../../Enum/WidgetTimeFilterEnum';
import { apiString as api } from '../../utils/constants';
import { MemberStatusEnum } from '../../Enum/MemberStatusEnum';
import { FacilityTypeEnum } from '../../Enum/FacilityTypeEnum';
import { ReferralDaysEnum } from '../../Enum/ReferralDaysEnum';
import { AppointmentTimeFilterEnum } from '../../Enum/AppointmentTimeFilterEnum';
import { TimeFilterEnum } from '../../Enum/TimeFilterEnum';
import { AppointmentTimeFrameEnum } from '../../Enum/AppointmentTimeFrameEnum';
import { DateContextTypeEnum } from '../../Enum/DateContextTypeEnum';
import { CarePlanNotReviewedPeriodEnum } from '../../Enum/CarePlanNotReviewedPeriodEnum';
import { TCVisitTypeEnum } from '../../Enum/TCVisitTypeEnum';
import { AdmissionRuleEnum } from '../../Enum/AdmissionRuleEnum';
import { TransitionalCareDateRangeEnum } from '../../Enum/TransitionalCareDateRangeEnum';
import { TCPerformanceFilterRoleEnum } from '../../Enum/TCPerformanceFilterRoleEnum';

export const selectedDayFilterList = function () {
    let dayList = [];
    dayList.push({ Id: WidgetTimeFilterEnum.Last7Days, Value: WidgetTimeFilterEnum.Last7DaysDescription });
    dayList.push({ Id: WidgetTimeFilterEnum.Last30Days, Value: WidgetTimeFilterEnum.Last30DaysDescription });
    dayList.push({ Id: WidgetTimeFilterEnum.Custom, Value: WidgetTimeFilterEnum.CustomDescription });
    return dayList;
};

export const dayFilterList = function () {
    let dayList = [];
    dayList.push({ Id: AppointmentTimeFrameEnum.Last7Days, Value: AppointmentTimeFrameEnum.Last7DaysDescription });
    dayList.push({ Id: AppointmentTimeFrameEnum.Last14Days, Value: AppointmentTimeFrameEnum.Last14DaysDescription });
    dayList.push({ Id: AppointmentTimeFrameEnum.Custom, Value: AppointmentTimeFrameEnum.CustomDescription });
    return dayList;
};

export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 50 * 4.5,
            width: 250,
        },
    },
};

export const fetchCptCodeGroups = async () => {
    const response = await axios.get(`${api}/encounter/getcptcodegroupspreview`);
    return response.data;
};

export const fetchRequestTypes = async () => {
    const response = await axios.get(`${api}/request/getrequesttype`);
    return response.data;
};

export const fetchSurveyChart = async (providerId: string, dateFilter: TimePeriodFilterEnum, dateFrom: string, dateTo: string, prepareMembers: boolean) => {
    const response = await axios.get(
        `${api}/widget/getsurveychart?providerId=${providerId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&prepareMembers=${prepareMembers}`
    );
    return response.data;
};

export const exportSurveyChart = async (providerId: string, dateFilter: TimePeriodFilterEnum, dateFrom: string, dateTo: string) => {
    const response = await axios.get(`${api}/widget/exportsurveychart?providerId=${providerId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
    return response.data;
};

export const fetchCleanClaimsChart = async (
    providerId: string,
    teamId: string,
    healthPlanIds: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includeInActiveTeams: boolean,
    includeInActiveProviders: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getcleanclaimschart?providerId=${providerId}&teamId=${teamId}&healthPlanIds=${healthPlanIds}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};
export const fetchSubmittedClaimsChart = async (
    providerId: string,
    teamId: string,
    healthPlanIds: string,
    includeInActiveTeams: boolean,
    includeInActiveProviders: boolean,
    prepareMembers: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getsubmittedclaimschart?providerId=${providerId}&teamId=${teamId}&healthPlanIds=${healthPlanIds}&includeInActiveTeams=${includeInActiveTeams}&includeInActiveProviders=${includeInActiveProviders}&prepareMembers=${prepareMembers}`
    );
    return response.data;
};
export const exportSubmittedClaimsChart = async (
    providerId: string,
    teamId: string,
    healthPlanIds: string,
    includeInActiveTeams: boolean,
    includeInActiveProviders: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportsubmittedclaimschart?providerId=${providerId}&teamId=${teamId}&healthPlanIds=${healthPlanIds}&includeInActiveTeams=${includeInActiveTeams}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};
export const fetchRevenueMetrics = async (healthPlanIds: string, geography: string, defaultDate: string, comparisonDate: string) => {
    const response = await axios.get(
        `${api}/widget/revenuemetrics?healthPlanIds=${healthPlanIds}&geography=${geography}&defaultDate=${defaultDate}&comparisonDate=${comparisonDate}`
    );
    return response.data;
};
export const fetchRevenueMetricsComparisonCount = async (
    healthPlanIds: string,
    geography: string,
    comparisonDate: string,
    status: MemberStatusEnum
) => {
    const response = await axios.get(
        `${api}/widget/revenuemetricscomparisoncount?healthPlanIds=${healthPlanIds}&geography=${geography}&comparisonDate=${comparisonDate}&status=${status}`
    );
    return response.data;
};
export const exportRevenueMetrics = async (healthPlanIds: string, geography: string, defaultDate: string, comparisonDate: string, dateContextType: DateContextTypeEnum) => {
    const response = await axios.get(
        `${api}/widget/exportrevenuemetrics?healthPlanIds=${healthPlanIds}&geography=${geography}&defaultDate=${defaultDate}&comparisonDate=${comparisonDate}&dateContextType=${dateContextType}`
    );
    return response.data;
};
export const fetchTeamInPersonVisitsRate = async (
    healthPlanIds: string,
    teamId: string,
    timeFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includeInActiveTeams: boolean,
    prepareMembers: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getteaminpersonvisitrate?healthPlanIds=${healthPlanIds}&teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}&prepareMembers=${prepareMembers}`
    );
    return response.data;
};
export const fetchTeamAppointmentHub = async (
    timeFilter: AppointmentTimeFrameEnum,
    healthPlanIds: string,
    providerId: string,
    teamId: string,
    schedulingStaff: string,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean,
    includeInActiveProviders?: boolean,
    includeInActiveStaffs?: boolean,
    prepareMembers?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getteamappointmenthub?timeFilter=${timeFilter}&healthPlanIds=${healthPlanIds}&providerId=${providerId}&teamId=${teamId}&schedulingStaff=${schedulingStaff}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}&includeInActiveProviders=${includeInActiveProviders}&includeInActiveStaffs=${includeInActiveStaffs}&prepareMembers=${prepareMembers}`
    );
    return response.data;
};
export const exportTeamAppointmentHub = async (
    timeFilter: WidgetTimeFilterEnum,
    healthPlanIds: string,
    providerId: string,
    teamId: string,
    schedulingStaff: string,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean,
    includeInActiveProviders?: boolean,
    includeInActiveStaffs?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportteamappointmenthub?timeFilter=${timeFilter}&healthPlanIds=${healthPlanIds}&providerId=${providerId}&teamId=${teamId}&schedulingStaff=${schedulingStaff}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}&includeInActiveProviders=${includeInActiveProviders}&includeInActiveStaffs=${includeInActiveStaffs}`
    );
    return response.data;
};
export const fetchDocumentationTrackingSummary = async (
    providerId: string,
    teamId: string,
    timeFilter: TimePeriodFilterEnum,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean,
    includeInActiveProviders?: boolean,
    prepareMembers?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getdocumentationtrackingsummary?providerId=${providerId}&teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}&includeInActiveProviders=${includeInActiveProviders}&prepareMembers=${prepareMembers}`
    );
    return response.data;
};

export const fetchSchedulerPerformanceHub = async (
    providerId: string,
    timeFilter: WidgetTimeFilterEnum,
    dateFrom?: string,
    dateTo?: string,
    prepareMembers?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getschedulerperformancehub?providerId=${providerId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&prepareMembers=${prepareMembers}`
    );
    return response.data;
};

export const exportSchedulerPerformanceHub = async (providerId: string, timeFilter: WidgetTimeFilterEnum, dateFrom?: string, dateTo?: string) => {
    const response = await axios.get(
        `${api}/widget/exportschedulerperformancehub?providerId=${providerId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}`
    );
    return response.data;
};

export const fetchTeamMemberSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getteammembersummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const fetchTeamScheduleNeedsSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getteamscheduleneedssummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const exportTeamScheduleNeedsSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportteamscheduleneedssummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const fetchEducationSessionReminder = async (teamId: string, showInActiveTeams?: boolean) => {
    const response = await axios.get(`${api}/widget/educationsessionreminder?teamId=${teamId}&includeInActiveTeams=${showInActiveTeams}`);
    return response.data;
};

export const exportEducationSessionReminder = async (teamId: string, showInActiveTeams?: boolean) => {
    const response = await axios.get(`${api}/widget/exporteducationsessionreminder?teamId=${teamId}&includeInActiveTeams=${showInActiveTeams}`);
    return response.data;
};

export const fetchCarePlanNotReviewedMembersChart = async (teamId: string, notReviewedPeriod: CarePlanNotReviewedPeriodEnum, date: string, showInActiveTeams: boolean) => {
    const response = await axios.get(`${api}/widget/getcareplannotreviewedmembers?teamId=${teamId}&notReviewedPeriod=${notReviewedPeriod}&date=${date}&includeInActiveTeams=${showInActiveTeams}`);
    return response.data;
};

export const exportCarePlanNotReviewedMembersChart = async (teamId: string, notReviewedPeriod: CarePlanNotReviewedPeriodEnum, date: string, showInActiveTeams: boolean) => {
    const response = await axios.get(`${api}/widget/exportcareplannotreviewedmembers?teamId=${teamId}&notReviewedPeriod=${notReviewedPeriod}&date=${date}&includeInActiveTeams=${showInActiveTeams}`);
    return response.data;
};

export const exportDocumentationTrackingSummary = async (
    providerId: string,
    teamId: string,
    timeFilter: TimePeriodFilterEnum,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean,
    includeInActiveProviders?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportdocumentationtrackingmembers?providerId=${providerId}&teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};
export const exportTeamInPersonVisitRate = async (
    healthPlanIds: string,
    teamId: string,
    timeFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportteaminpersonvisitrate?healthPlanIds=${healthPlanIds}&teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const exportTeamMemberSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportteammembersummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const fetchFuhFumUndeterminedSummary = async (referralDays: ReferralDaysEnum, includeScheduledStatus?: boolean) => {
    const response = await axios.get(`${api}/fuhfum/fuhfumundeterminedwidget?referralDays=${referralDays}&includeScheduledStatus=${includeScheduledStatus}`);
    return response.data;
};

export const exportFuhFumUndeterminedSummary = async (referralDays: ReferralDaysEnum, includeScheduledStatus?: boolean) => {
    const response = await axios.get(
        `${api}/fuhfum/exportfuhfumundeterminedmembers?referralDays=${referralDays}&includeScheduledStatus=${includeScheduledStatus}`
    );
    return response.data;
};

export const fetchFuhFumInProgressSummary = async (
    provider: string,
    daysSinceDischarge: string,
    timeFilter: WidgetTimeFilterEnum,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveProviders?: boolean
) => {
    const response = await axios.get(
        `${api}/fuhfum/fuhfuminprogresswidget?provider=${provider}&daysSinceDischarge=${daysSinceDischarge}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};

export const exportFuhFumInProgressSummary = async (
    provider: string,
    daysSinceDischarge: string,
    timeFilter: WidgetTimeFilterEnum,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveProviders?: boolean
) => {
    const response = await axios.get(
        `${api}/fuhfum/exportfuhfuminprogressmembers?provider=${provider}&daysSinceDischarge=${daysSinceDischarge}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};

export const fetchFuhFumExceptionSummary = async () => {
    const response = await axios.get(`${api}/fuhfum/fuhfumexceptionwidget`);
    return response.data;
};

export const exportFuhFumExceptionSummary = async () => {
    const response = await axios.get(`${api}/fuhfum/exportfuhfumexceptionmembers`);
    return response.data;
};

export const fetchFuhFumQualityMetrics = async (timeFilter: WidgetTimeFilterEnum, dateFrom?: string, dateTo?: string, prepareMembers?: boolean) => {
    const response = await axios.get(
        `${api}/fuhfum/fuhfumqualitymetrics?timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&prepareMembers=${prepareMembers}`
    );
    return response.data;
};

export const exportFuhFumQualityMetrics = async (timeFilter: WidgetTimeFilterEnum, dateFrom?: string, dateTo?: string) => {
    const response = await axios.get(`${api}/fuhfum/exportfuhfumqualitymetrics?timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
    return response.data;
};
export const fetchTransitionalCareSummary = async (
    facility: FacilityTypeEnum,
    admissionRule: AdmissionRuleEnum,
    tcType: TCVisitTypeEnum,
    teamId: string,
    timeFilter: TransitionalCareDateRangeEnum,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/gettransitionalcaresummary?facility=${facility}&admissionRule=${admissionRule}&tcType=${tcType}&teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const exportTransitionalCareSummary = async (
    facility: FacilityTypeEnum,
    admissionRule: AdmissionRuleEnum,
    teamId: string,
    timeFilter: TransitionalCareDateRangeEnum,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exporttransitionalcaresummary?facility=${facility}&admissionRule=${admissionRule}&teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const fetchTransitionalCarePerformance = async (
    teamId: string,
    tcPerformanceFilterRole: TCPerformanceFilterRoleEnum,
    timeFilter: TransitionalCareDateRangeEnum,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/gettransitionalcareperformance?teamId=${teamId}&tcPerformanceFilterRole=${tcPerformanceFilterRole}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const exportTransitionalCarePerformance = async (
    teamId: string,
    tcPerformanceFilterRole: TCPerformanceFilterRoleEnum,
    timeFilter: TransitionalCareDateRangeEnum,
    dateFrom?: string,
    dateTo?: string,
    includeInActiveTeams?: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exporttransitionalcareperformance?teamId=${teamId}&tcPerformanceFilterRole=${tcPerformanceFilterRole}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const fetchIndividualProviderVisitPerformance = async (
    providerId: string,
    timeFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includeInActiveProviders: boolean,
    prepareMembers: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getindividualprovidervisitperformance?providerId=${providerId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveProviders=${includeInActiveProviders}&prepareMembers=${prepareMembers}`
    );
    return response.data;
};
export const exportIndividualProviderVisitPerformance = async (
    providerId: string,
    timeFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includeInActiveProviders: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportindividualprovidervisitperformance?providerId=${providerId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};

export const fetchOnboardCallingPerformance = async (
    providerId: string,
    populationTypes: string,
    timeFilter: string,
    dateFrom: string,
    dateTo: string,
    includeInActiveProviders: boolean
) => {
    const response = await axios.get(
        `${api}/widget/getonboardcallingperformance?providerId=${providerId}&populationTypes=${populationTypes}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};

export const fetchNeedingRescheduleMembers = async (
    providerId: string,
    populationTypes: string,
    timeFilter: string,
    dateFrom: string,
    dateTo: string,
    includeInActiveProviders: boolean,
    pageSize: number,
    pageNumber: number
) => {
    const response = await axios.get(
        `${api}/widget/getneedingreschedulemembers?providerId=${providerId}&populationTypes=${populationTypes}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveProviders=${includeInActiveProviders}&pageSize=${pageSize}&pageNumber=${pageNumber}`
    );
    return response.data;
};

export const exportNeedingRescheduleMembers = async (
    providerId: string,
    populationTypes: string,
    timeFilter: string,
    dateFrom: string,
    dateTo: string,
    includeInActiveProviders: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportneedingreschedulemembers?providerId=${providerId}&populationTypes=${populationTypes}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};

export const fetchProviderCalls = async (
    providerId: string,
    populationTypes: string,
    timeFilter: string,
    dateFrom: string,
    dateTo: string,
    includeInActiveProviders: boolean,
    pageSize: number,
    pageNumber: number
) => {
    const response = await axios.get(
        `${api}/widget/getprovidercalls?providerId=${providerId}&populationTypes=${populationTypes}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveProviders=${includeInActiveProviders}&pageSize=${pageSize}&pageNumber=${pageNumber}`
    );
    return response.data;
};

export const ExportProviderCalls = async (
    providerId: string,
    populationTypes: string,
    timeFilter: string,
    dateFrom: string,
    dateTo: string,
    includeInActiveProviders: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportprovidercalls?providerId=${providerId}&populationTypes=${populationTypes}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};

export const fetchMembersNotScheduledWithBHOrNP = async (
    teamId: string,
    timeFilter: AppointmentTimeFilterEnum,
    dateFrom: string,
    dateTo: string,
    includeInActiveTeams: boolean,
) => {
    const response = await axios.get(
        `${api}/widget/getmembersnotscheduledwithbhornp?teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const exportMembersNotScheduledWithBHOrNP = async (
    teamId: string,
    timeFilter: AppointmentTimeFilterEnum,
    dateFrom: string,
    dateTo: string,
    includeInActiveTeams: boolean,
) => {
    const response = await axios.get(
        `${api}/widget/exportmembersnotscheduledwithbhornp?teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const fetchFuhFumVisitsWidget = async (timeFilter: WidgetTimeFilterEnum, dateFrom?: string, dateTo?: string) => {
    const response = await axios.get(`${api}/fuhfum/fuhfumvisitswidget?timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
    return response.data;
};

export const fetchFuhFumReadmissionsWidget = async (timeFilter: WidgetTimeFilterEnum, dateFrom?: string, dateTo?: string) => {
    const response = await axios.get(`${api}/fuhfum/fuhfumreadmissionswidget?timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
    return response.data;
};

export const fetchFuhFumOrHraFullProgramReferral = async (timeFilter: WidgetTimeFilterEnum, dateFrom?: string, dateTo?: string, prepareMembers?: boolean) => {
    const response = await axios.get(
        `${api}/widget/fuhfumorhrafullprogramreferral?timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&prepareMembers=${prepareMembers}`
    );
    return response.data;
};

export const exportFullProgramReferralSummary = async (timeFilter: TimePeriodFilterEnum, dateFrom: string, dateTo: string) => {
    const response = await axios.get(`${api}/widget/exportfullprogramreferrals?timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
    return response.data;
};

export const fetchFuhFumOrHraFullProgramReferralTagWidget = async (memberName: string) => {
    const response = await axios.get(`${api}/widget/getfuhfumorhrafullprogramreferraltagwidget?memberName=${memberName}`);
    return response.data;
};

export const exportFuhFumOrHraFullProgramReferralTagWidget = async (memberName: string) => {
    const response = await axios.get(`${api}/widget/exportfuhfumorhrafullprogramreferraltagwidget?memberName=${memberName}`);
    return response.data;
};

export const fetchAppointmentsNotDocumentedWidget = async (providerId: string, timePeriodFilter: TimeFilterEnum, dateFrom?: string, dateTo?: string) => {
    const response = await axios.get(
        `${api}/widget/getappointmentsnotdocumentedwidget?providerId=${providerId}&timePeriodFilter=${timePeriodFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}`
    );
    return response.data;
};

export const exportAppointmentsNotDocumentedWidget = async (providerId: string, timePeriodFilter: TimeFilterEnum, dateFrom?: string, dateTo?: string) => {
    const response = await axios.get(
        `${api}/widget/exportappointmentsnotdocumentedwidget?providerId=${providerId}&timePeriodFilter=${timePeriodFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}`
    );
    return response.data;
};

export const fetchMemberPromisesByTeam = async (requestTypeId: string, filterBy: string, teamId: string, providerId: string, includeInActiveTeams: boolean, includeInActiveProviders: boolean, dateFrom?: string, dateTo?: string) => {
    const response = await axios.get(
        `${api}/widget/getmemberpromisesbyteam?requestTypeId=${requestTypeId}&filterBy=${filterBy}&dateFrom=${dateFrom}&dateTo=${dateTo}&teamId=${teamId}&providerId=${providerId}&includeInActiveTeams=${includeInActiveTeams}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};

export const exportMemberPromisesByTeam = async (requestTypeId: string, filterBy: string, teamId: string, providerId: string, includeInActiveTeams: boolean, includeInActiveProviders: boolean, dateFrom?: string, dateTo?: string) => {
    const response = await axios.get(
        `${api}/widget/exportmemberpromisesbyteam?requestTypeId=${requestTypeId}&filterBy=${filterBy}&dateFrom=${dateFrom}&dateTo=${dateTo}&teamId=${teamId}&providerId=${providerId}&includeInActiveTeams=${includeInActiveTeams}&includeInActiveProviders=${includeInActiveProviders}`
    );
    return response.data;
};

export const fetchPatientsAdmittedInPastDays = async (
    teamId: string,
    timeFilter: WidgetTimeFilterEnum,
    dateFrom: string,
    dateTo: string,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/widget/patientsasmittedinpastdays?teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const exportPatientsAdmittedInPastDays = async (
    teamId: string,
    timeFilter: WidgetTimeFilterEnum,
    dateFrom: string,
    dateTo: string,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exportpatientsasmittedinpastdays?teamId=${teamId}&timeFilter=${timeFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const fetchHighCostMembers = async (
    healthPlanIds: string,
    team: string,
    years: string,
    months: string,
    showInActiveTeams: boolean) => {
    const response = await axios.get(
        `${api}/widget/gethighcostmembers?healthPlanIds=${healthPlanIds}&team=${team}&years=${years}&months=${months}&showInActiveTeams=${showInActiveTeams}`
    );
    return response.data;
};

export const exportHighCostMembers = async (
    healthPlanIds: string,
    team: string,
    years: string,
    months: string,
    showInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/widget/exporthighcostmembers?healthPlanIds=${healthPlanIds}&team=${team}&years=${years}&months=${months}&showInActiveTeams=${showInActiveTeams}`
    );
    return response.data;
};

export const fetchOnboardingPerformance = async () => {
    const response = await axios.get(`${api}/widget/getonboardingperformance`);
    return response.data;
};

export const exportOnboardingPerformance = async () => {
    const response = await axios.get(`${api}/widget/exportonboardingperformance`);
    return response.data;
};

export const fetchMissingOrExpiredConsents = async (teamId: string, documentType: number, includeInActiveTeams: boolean) => {
    const response = await axios.get(
        `${api}/widget/getmissingorexpiredconsents?teamId=${teamId}&documentType=${documentType}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const exportMissingOrExpiredConsents = async (teamId: string, includeInActiveTeams: boolean) => {
    const response = await axios.get(
        `${api}/widget/exportmissingorexpiredconsents?teamId=${teamId}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const fetchMembersWithNoPrimaryDiagnosis = async (teamId: string, includeInActiveTeams: boolean) => {
    const response = await axios.get(`${api}/widget/getmemberswithnoprimarydiagnosis?teamId=${teamId}&includeInActiveTeams=${includeInActiveTeams}`);
    return response.data;
};

export const exportMembersWithNoPrimaryDiagnosis = async (teamId: string, includeInActiveTeams: boolean) => {
    const response = await axios.get(`${api}/widget/exportmemberswithnoprimarydiagnosis?teamId=${teamId}&includeInActiveTeams=${includeInActiveTeams}`);
    return response.data;
};

export const fetchTransitionalCareWidget = async (teamId: string, includeInActiveTeams: boolean) => {
    const response = await axios.get(`${api}/widget/transitionalcarewidget?teamId=${teamId}&includeInActiveTeams=${includeInActiveTeams}`);
    return response.data;
};

export const exportTransitionalCareWidget = async (teamId: string, includeInActiveTeams: boolean) => {
    const response = await axios.get(`${api}/widget/exporttransitionalcarewidget?teamId=${teamId}&includeInActiveTeams=${includeInActiveTeams}`);
    return response.data;
};

export const fetchMedicalDocumentsToReview = async (timePeriodFilter: number, teamId: string, includeInActiveTeams: boolean) => {
    const response = await axios.get(`${api}/widget/getmedicaldocumentstoreview?timePeriodFilter=${timePeriodFilter}&teamId=${teamId}&includeInActiveTeams=${includeInActiveTeams}`);
    return response.data;
};

export const markAsReviewed = async (documentId: string) => {
    const response = await axios.post(`${api}/widget/markasreviewed?documentId=${documentId}`);
    return response.data;
};

export const exportMedicalDocumentsToReview = async (timePeriodFilter: number, teamId: string, includeInActiveTeams: boolean) => {
    const response = await axios.get(`${api}/widget/exportmedicaldocumentstoreview?timePeriodFilter=${timePeriodFilter}&teamId=${teamId}&includeInActiveTeams=${includeInActiveTeams}`);
    return response.data;
};

export const fetchAndNextCensusSummary = async () => {
    const response = await axios.get(`${api}/widget/getandnextcensussummary`);
    return response.data;
};

export const exportAndNextCensusSummary = async () => {
    const response = await axios.get(`${api}/widget/exportandnextcensussummary`);
    return response.data;
};

export const fetchProvidersByRoles = async () => {
    const response = await axios.get(`${api}/widget/getprovidersbyroles`);
    return response.data;
};
